module.exports = __webpack_public_path__ + "img/writing-fluently-background.29388bd4.svg";